<template>
  <div id="snackbar">
    <span>{{ $t("snackbarMessage") }}</span>
  </div>
</template>
<script>
export default {
  name: "Snackbar",
  props: {
    showSnackbar: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showSnackbar() {
      if (this.showSnackbar) {
        const x = document.getElementById("snackbar");
        x.className = "show";
        setTimeout(function() {
          x.className = x.className.replace("show", "");
        }, 5000);
      }
    }
  }
};
</script>
<style scoped>
#snackbar {
  visibility: hidden;
  font-family: Roboto;
  width: 90%;
  left: 5%;
  background-color: #3b56ff;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  bottom: 110px;
  font-size: 14px;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
</style>
